import React, { useEffect } from 'react';
import Layout from '@/common/Layout';
import FeebBack from './components/FeebBack';

const index = () => {
  useEffect(() => {
    document.title = 'Share your feedback - Help us improve';
  }, []);

  return (
    <>
      <Layout sider={true}>
        <FeebBack />
      </Layout>
    </>
  );
};

export default index;
